import React, { useState, useEffect } from 'react'
import callPostApi from 'requests/PostRequests';
import DashboardSummary from '../DashboardSummaryNew';
import * as Constants from '../../../requests/URLConstants';
import DashboardTable from '../DashboardTable';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import { TableToolbar, TableToolbarContent, TableToolbarSearch } from 'carbon-components-react'
import * as tableHeaders from './tableHeaders';
import DetailedUtilizationReport from './DetailedUtilizationReport';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

require("./_capacity-management.scss");

const CapacityManagement = (props) => {
    const [botOnBoardingReport, setBotOnBoardingReport] = useState([]);
    const [searchedBotOnBoardingReport, setSearchedBotOnBoardingReport] = useState([]);
    const [botOnBoardingReportLoading, setBotOnBoardingReportLoading] = useState(false);
    const [resourceUtilizationData, setResourceUtilizationData] = useState([]);
    const [resourceUtilizationLoading, setResourceUtilizationLoading] = useState(false);
    const [capacityManagementSummaryData, setCapacityManagementSummaryData] = useState([]);

    const getCapacityManagementSummaryData = (param) => {
        let summary = [{
            title: DashboardConstants.NoOfResources,
            value: param.resources
        },
        {
            title: DashboardConstants.AverageUtilization,
            value: isNaN(param.averageUtilization) ? 0 : param.averageUtilization,
            showPercent: true
        },
        {
            title: DashboardConstants.BotsExceedingUtilization,
            value: param.exceedingUtilization
        }]
        setCapacityManagementSummaryData(summary);
    };

    useEffect(() => {
        //console.log("Capacity Management Click");
        getResourceUtilization(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getBotOnBoardingReport(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if(workspace === workspaces.automation_ops){
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client =  dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "geos": dashboardFilterSelectionsAutomation.geo,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "resource": dashboardFilterSelectionsAutomation.resource,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id
                },
                "interval":{
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    const prepareBotOnboardingData = (response) => {
        let tableData = [];
        let tableObj = {};
        let statusBucket = [];
        if (response) {
            let buckets = response.aggregations["2"].buckets;
            for (let i = 0; i < buckets.length; i++) {
                statusBucket = buckets[i]["8"].buckets;
                for (let j = 0; j < statusBucket.length; j++) {
                    tableObj = {
                        id: Math.random(),
                        automataName: buckets[i].key,
                        client: '',
                        model: statusBucket[j].key ? statusBucket[j].key : '-',
                        onBoardingDate: statusBucket[j]["10"] && statusBucket[j]["10"].hits && statusBucket[j]["10"].hits.hits[0]? statusBucket[j]["10"].hits.hits[0].fields.Onboarding_dt[0] : '-',
                        offBoardingDate: statusBucket[j]["11"] && statusBucket[j]["11"].hits && statusBucket[j]["11"].hits.hits[0] ? statusBucket[j]["11"].hits.hits[0].fields.offboarding_string[0] : '-',
                        status: statusBucket[j]["12"] && statusBucket[j]["12"].hits && statusBucket[j]["12"].hits.hits[0] ? statusBucket[j]["12"].hits.hits[0].fields.Status[0] : '-',
                        executions: statusBucket[j].doc_count ? statusBucket[j].doc_count : '-'
                    }
                    tableData.push(tableObj);
                }
            }
        }
        return tableData;
    };

    const getBotOnBoardingReport = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setBotOnBoardingReportLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTONBOARDINGREPORT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareBotOnboardingData(resp);
                setBotOnBoardingReport(formattedData);
                setBotOnBoardingReportLoading(false);
            }).catch((error) => {
                setBotOnBoardingReportLoading(false);
            });
        }
    };

    const prepareResourceUtilizationData = (response) => {
        let tableData = [];
        let tableObj = {};
        let summaryData = {};
        let totalUtilization = 0;
        let exceedingUtilization = 0;
        let utilization = 0;
        if(response) {
            for(let i = 0; i < response.length; i++){
                utilization = response[i].utilization ? Number(response[i].utilization) : 0;
                tableObj = {
                    id: (i+1).toString(),
                    resource: response[i].resource,
                    utilization: utilization ? utilization.toFixed(2)+"%" : '-'
                }
                totalUtilization = totalUtilization + utilization;
                exceedingUtilization = utilization > 80 ? exceedingUtilization + 1 : exceedingUtilization;
                tableData.push(tableObj);
            }
            summaryData = {
                resources: response.length,
                averageUtilization: (totalUtilization / response.length).toFixed(2),
                exceedingUtilization : exceedingUtilization
            }
        }
        return {tableData, summaryData };
    };

    const getResourceUtilization = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setResourceUtilizationLoading(true);
            let formattedData = [];
            // send minTime, maxtime in epoch format
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETBOTUTILIZATION, {
                'Content-Type': 'application/json'
            }, bodyJSON)
            .then(resp => {
                formattedData = prepareResourceUtilizationData(resp);
                setResourceUtilizationData(formattedData.tableData);
                getCapacityManagementSummaryData(formattedData.summaryData)
                setResourceUtilizationLoading(false);
            }).catch((error) => {
                setResourceUtilizationLoading(false);
            });
        }
    };

    const searchTable = (event) => {
        let searchString = (event.target.value).toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            newList = botOnBoardingReport.filter(element => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        string = element[property] ? element[property] : '';
                        string = string ? string.toString() : '';
                        pattern = new RegExp('(\\w*' + searchString + '\\w*)', 'gi');
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            setSearchedBotOnBoardingReport(newList);
        } else {
            setSearchedBotOnBoardingReport(botOnBoardingReport);
        }
    };

    return (
        <div className="top-margin dashboard capacity-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={resourceUtilizationLoading} summary={capacityManagementSummaryData} title={DashboardConstants.CapacityManagementSummary} />
                </div>
                <div className="dashboard-charts-container">
                    <DetailedUtilizationReport getPayload={getPayload} preferencesChanged={props.preferencesChanged} timeFilterSelections={props.timeFilterSelections} filterSelectionsAutomation={props.filterSelectionsAutomation}
                    filterSelectionsSAP={props.filterSelectionsSAP} workspace={props.workspace} />
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.ResourceUtilizationReport}</div>
                            <div className="download-button">
                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={resourceUtilizationData} headers={tableHeaders.resourceUtilizationHeaders} title={DashboardConstants.ResourceUtilizationReport} filename={DashboardConstants.ResourceUtilizationFileName} label={DashboardConstants.Download} />
                            </div>                                                                                             
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={resourceUtilizationLoading} rows={resourceUtilizationData} headers={tableHeaders.resourceUtilizationHeaders}
                            showPagination={true} isSortable={true} />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.AutomataOnboardingReport}</div>
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                    <TableToolbarSearch onChange={searchTable} />
                                    </TableToolbarContent>
                                </TableToolbar>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={botOnBoardingReport} headers={tableHeaders.automataOnboardingHeaders} title={DashboardConstants.AutomataOnboardingReport} filename={DashboardConstants.AutomataOnBoardingReportFileName} label={DashboardConstants.Download} />
                                </div>
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={botOnBoardingReportLoading} rows={searchedBotOnBoardingReport.length ? searchedBotOnBoardingReport : botOnBoardingReport} headers={tableHeaders.automataOnboardingHeaders}
                            showPagination={true} isSortable={true} />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default CapacityManagement;
